import React from "react";
import { HorizontalTabs } from "src/components/Tabs/HorizontalTabs";
import { CreateWorkRequestTabsProps } from "../types";

const CreateFormTabs = ({ activeTab, setActiveTab, tabs }: CreateWorkRequestTabsProps) => {
  return (
    <HorizontalTabs
      tabs={tabs.map((tab) => ({
        eventKey: tab.eventKey,
        label: tab.label,
        content: activeTab === tab.eventKey ? <></> : null,
      }))}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
};

export default CreateFormTabs;
